import { Promo } from "../entities/promo-entity";
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';


export class PromoRequest extends BaseRequest {
    promo : Promo;
}
